import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function ArrowDownIcon(props: IconProps): ReactElement {
  const { width = 24, height = 24, className = "" } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <path d="M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z" />
    </svg>
  );
}
